import React, { useEffect } from 'react';
import MetaTags from 'react-meta-tags';
import '../styles/privacypolicy.css';

export default function PrivacyPolicyPage() {
  const company = 'PolyLearning Edu.';
  const site = 'PolyQuizz';
  const supportEmail = 'support@polyquizz.com';

    // Scroll to top on mount
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);

  return (
    <>
      <MetaTags>
        <title>Privacy Policy — PolyQuizz</title>
        <meta
          name="description"
          content="Privacy Policy for PolyQuizz by PolyLearning Edu. Learn what information we collect, how we use it, and how we protect your privacy."
        />
      </MetaTags>

      

      <main className="privacy-hero" aria-labelledby="privacy-title">
        <div className="privacy-container">
          <header className="privacy-header">
            <h1 id="privacy-title">Privacy Policy</h1>
            <p className="privacy-sub">
              This policy explains how {company} collects, uses, and protects information when you use {site}.
              By using {site}, you accept the practices described here.
            </p>
          </header>

          <section className="privacy-section">
            <h2>1. Information we collect</h2>
            <p>
              We collect information you provide when you register, sign up for newsletters, contact support, or use
              interactive features (for example: name, username, email, and account preferences). We also collect data
              generated by your activity on the site (such as quiz results, time spent, and device information).
            </p>
          </section>

          <section className="privacy-section">
            <h2>2. How we use information</h2>
            <p>
              We use collected data to deliver and improve our services: create and score quizzes, show relevant content,
              provide customer support, and send transactional messages (account actions, confirmations, and security
              notices). With your consent we may send promotional emails; you can opt out at any time.
            </p>
          </section>

          <section className="privacy-section">
            <h2>3. Cookies & tracking</h2>
            <p>
              We use cookies and similar technologies to remember preferences, analyze site use, and improve performance.
              Third parties (for example analytics and advertising providers) may also set cookies when you visit
              {site}. You can control or block cookies through your browser settings, but some features may not work
              correctly if cookies are disabled.
            </p>
          </section>

          <section className="privacy-section">
            <h2>4. Logs & IP addresses</h2>
            <p>
              We automatically log certain technical information such as IP addresses, browser type, pages visited, and
              timestamps. This data helps us diagnose problems, prevent abuse, and generate aggregated usage reports. We
              normally keep personally identifiable logs only as long as necessary for the stated purpose.
            </p>
          </section>

          <section className="privacy-section">
            <h2>5. Sharing & third parties</h2>
            <p>
              We do not sell your personal information. We may share data with trusted service providers who perform
              services on our behalf (hosting, payments, analytics). These providers are contractually bound to protect
              your data. We may disclose information when required by law, to protect our rights or users, or in the
              event of a business transfer (sale, merger, or acquisition).
            </p>
          </section>

          <section className="privacy-section">
            <h2>6. Security</h2>
            <p>
              We implement industry-standard technical and organizational measures (for example HTTPS/SSL, secure
              servers, and access controls) to protect personal data. However, no transmission over the internet is
              completely secure. You share information at your own risk and should protect account credentials.
            </p>
          </section>

          <section className="privacy-section">
            <h2>7. Data retention & access</h2>
            <p>
              We retain data as long as needed to provide services, comply with legal obligations, resolve disputes, and
              enforce agreements. You may access, correct, or request deletion of your personal data by contacting us at
              {` `}<a href={`mailto:${supportEmail}`}>{supportEmail}</a>. We will respond in accordance with applicable law.
            </p>
          </section>

          <section className="privacy-section">
            <h2>8. International transfers</h2>
            <p>
              {site} operates globally. Your information may be stored and processed in India or other countries. By
              using {site} you consent to cross-border data transfers necessary to operate our services.
            </p>
          </section>

          <section className="privacy-section">
            <h2>9. Third-party links</h2>
            <p>
              Our site may link to external websites. We are not responsible for their content or privacy practices. Please
              review the privacy policies of any site you visit from {site}.
            </p>
          </section>

          <section className="privacy-section">
            <h2>10. Changes to this policy</h2>
            <p>
              We may update this policy from time to time. When we make material changes, we will post the revised policy
              with an updated “Last updated” date. Continued use after changes indicates acceptance.
            </p>
          </section>

          <footer className="privacy-contact">
            <p>
              Questions or requests about this policy? Contact {company} at{' '}
              <a href={`mailto:${supportEmail}`}>{supportEmail}</a>.
            </p>
            <p className="privacy-meta">Last updated: October 2025</p>
          </footer>
        </div>
      </main>

    
    </>
  );
}
